import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { DropDownMenu, Button } from "../../index";

export const DropDownButtonMenu = React.forwardRef(({
    buttonAs,
    buttonProps,
    disabled = false,
    id,
    onBlur = () => { },
    onSelect = () => { },
    options
}, ref) => {

    const dropdownRef = ref;
    const ButtonElement = buttonAs ? buttonAs : Button;
    const [showOptions, setShowOptions] = React.useState(false);

    const handleClick = (e, value, label, index) => {

        onSelect(e, value, label, index);
        setShowOptions(false);

        let eventBlur = {
            ...event, type: 'blur'
        }

        onBlur(eventBlur);
    }

    const toggleOptions = (e) => {
        setShowOptions(!showOptions);

        if (buttonProps && buttonProps?.onClick) {
            buttonProps?.onClick();
        }
    }

    const handleBlur = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setShowOptions(false);

            if (onBlur) {
                onBlur(event);
            }
        }
    }

    // Event handler for keydowns
    const handleOptionsKeyDown = (e, value, label, index) => {
        switch (e.key) {
            case " ":
            case "SpaceBar":
            case "Enter":
                e.preventDefault();
                e.persist();
                handleClick(e, value, label, index);
                break;
            case "Escape":
                e.preventDefault();
                setShowOptions(false);
            default:
                break;
        }
    };

    const dropdownClasses = [
        `mybswh-dropdown-menu-button`,
        `${disabled ? 'mybswh-dropdown-menu-button--disabled' : ''}`,
    ].join(' ');

    return (
        <div className={dropdownClasses} onBlur={handleBlur}>
            <ButtonElement
                {...buttonProps}
                disabled={disabled}
                onClick={toggleOptions}
                role="combobox"
                aria-owns={`${id}-list`}
                aria-haspopup="listbox"
                aria-expanded={showOptions}
            />
            {(options && showOptions && !disabled) &&
                <DropDownMenu
                    id={id}
                    onClick={handleClick}
                    onKeyDown={handleOptionsKeyDown}
                    options={options}
                    required={true}
                />
            }
        </div>
    )
});

DropDownButtonMenu.propTypes = {
    buttonAs: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
    buttonProps: PropTypes.object,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    onBlur: PropTypes.func,
    onSelect: PropTypes.func,
    options: PropTypes.array,
}
